import { Tabs } from "antd";
import { PlacementPositions } from "../../enums/PlacementPositionsEnums";
import ContactsTable from "./ContactsTable";
import DocumentsTable from "./DocumentsTable";
import NotesTable from "./NotesTable";
import { TableConstants } from "./constants";
import { DatabaseSections } from "../../enums/DatabaseEnums";
import { DatabaseCommonTableProps } from "../../Types/DatabaseTabTypes";
import { useCallback, useState } from "react";
import styles from "./DatabaseTab.module.scss";

const DatabaseTab = (props?: DatabaseCommonTableProps) => {
  const { TabPane } = Tabs;
  const {
    section,
    sectionId,
    prependTabs = [],
    isQuarry = false,
    blockedJob = false,
    isJob = false,
  } = props;
  const {
    HEADERS: { CONTACTS_HEADER, DOCUMENTS_HEADER, NOTES_HEADER },
    KEYS: { CONTACTS_KEY, DOCUMENTS_KEY, NOTES_KEY },
  } = TableConstants;
  const [notesCount, setNotesCount] = useState<number>(0);
  const NotesHeader = useCallback(
    () => (
      <div className={styles.notesHeader}>
        {NOTES_HEADER}
        <div className={styles.notesCount}>{notesCount}</div>
      </div>
    ),
    [notesCount],
  );
  const customTabs = prependTabs?.map((tab) => (
    <TabPane tab={tab?.label} key={tab?.key}>
      {tab?.children}
    </TabPane>
  ));
  return (
    <Tabs
      className={styles.CustomTab}
      tabPosition={PlacementPositions.TOP}
      destroyInactiveTabPane={isQuarry}
    >
      {customTabs}
      <TabPane tab={CONTACTS_HEADER} key={CONTACTS_KEY}>
        <ContactsTable
          section={section}
          sectionId={sectionId}
          isQuarry={isQuarry}
          blockedJob={blockedJob}
        />
      </TabPane>
      <TabPane tab={DOCUMENTS_HEADER} key={DOCUMENTS_KEY}>
        <DocumentsTable
          isJob={isJob}
          section={section}
          sectionId={sectionId}
          isQuarry={isQuarry}
          blockedJob={blockedJob}
        />
      </TabPane>
      <TabPane forceRender={true} tab={NotesHeader()} key={NOTES_KEY}>
        <NotesTable
          section={section}
          sectionId={sectionId}
          setNotesCount={setNotesCount}
          blockedJob={blockedJob}
        />
      </TabPane>
    </Tabs>
  );
};

export default DatabaseTab;
